import { render, staticRenderFns } from "./News1.vue?vue&type=template&id=01266edf&scoped=true&"
import script from "./News1.vue?vue&type=script&lang=js&"
export * from "./News1.vue?vue&type=script&lang=js&"
import style0 from "./News1.vue?vue&type=style&index=0&id=01266edf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01266edf",
  null
  
)

export default component.exports